import { defineStore } from 'pinia';
import { useLocalStorage } from '@vueuse/core';
export var useFormStore = defineStore('form', function () {
  var abTest = ref(useLocalStorage('fitleads-ab-test', false));
  var gym = ref(useLocalStorage('fitleads-gym', {
    id: null,
    name: null,
    youTubeUrl: null,
    homeProgramUrl: null,
    isAddonRequired: null,
    isCefEnabled: null,
    promotion: null,
    appointmentModuleEnabled: null,
    appointmentFrameUrl: null
  }));
  var resetGym = function resetGym() {
    gym.value = {
      id: null,
      name: null,
      youTubeUrl: null,
      homeProgramUrl: null,
      isAddonRequired: null,
      isCefEnabled: null,
      appointmentModuleEnabled: null,
      appointmentFrameUrl: null
    };
  };
  var membershipType = ref(useLocalStorage('fitleads-membership-type', {
    accesKeyPrice: null,
    membership: {
      type: null
    },
    type: null,
    duration: null,
    registrationFeePrice: 0,
    promotion: null
  }));
  var resetMembershipAndAddons = function resetMembershipAndAddons() {
    membershipType.value = {
      accesKeyPrice: null,
      membership: {
        type: null
      },
      type: null,
      duration: null,
      registrationFeePrice: 0
    };
    optionalExtras.value = {};
  };
  var optionalExtras = ref(useLocalStorage('fitleads-optional-extras', {}));
  var personalInformation = ref(useLocalStorage('fitleads-personal-information', {
    firstName: null,
    lastName: null,
    birthdate: null,
    gender: null,
    email: null,
    phoneNumber: null
  }));
  var addressInformation = ref(useLocalStorage('fitleads-address-information', {
    postalCode: null,
    houseNumber: null,
    houseNumberAddition: null,
    street: null,
    city: null
  }));
  var paymentInformation = ref(useLocalStorage('fitleads-payment-information', {
    accountHolder: null,
    accountNumber: null,
    paymentFrequency: null,
    terms: null,
    sepa: null
  }));
  var steps = ref(useLocalStorage('fitleads-steps', {
    gym: false,
    membership: false,
    personalInformation: false,
    optionalExtras: false,
    payment: false
  }));
  var resetSteps = function resetSteps() {
    steps.value = {
      gym: false,
      membership: false,
      personalInformation: false,
      optionalExtras: false,
      payment: false
    };
  };
  var clubHasAddons = ref(useLocalStorage('fitleads-club-has-addons', false));
  var summary = ref(useLocalStorage('fitleads-summary', {
    monthlyPrice: null,
    optionalExtras: {},
    membershipType: {
      membership: {
        type: null
      },
      type: null,
      duration: null,
      promotion: null
    }
  }));
  var campaign = ref(useLocalStorage('fitleads-campaign', null));
  var referral = ref(useLocalStorage('fitleads-referral', null));
  var clearStore = function clearStore() {
    localStorage.removeItem('fitleads-ab-test');
    localStorage.removeItem('fitleads-gym');
    localStorage.removeItem('fitleads-membership-type');
    localStorage.removeItem('fitleads-optional-extras');
    localStorage.removeItem('fitleads-personal-information');
    localStorage.removeItem('fitleads-address-information');
    localStorage.removeItem('fitleads-payment-information');
    localStorage.removeItem('fitleads-steps');
    localStorage.removeItem('fitleads-summary');
    localStorage.removeItem('fitleads-club-has-addons');
    localStorage.removeItem('fitleads-campaign');
    localStorage.removeItem('fitleads-referral');
  };
  return {
    abTest: abTest,
    gym: gym,
    resetGym: resetGym,
    membershipType: membershipType,
    resetMembershipAndAddons: resetMembershipAndAddons,
    optionalExtras: optionalExtras,
    personalInformation: personalInformation,
    addressInformation: addressInformation,
    paymentInformation: paymentInformation,
    steps: steps,
    resetSteps: resetSteps,
    clubHasAddons: clubHasAddons,
    summary: summary,
    clearStore: clearStore,
    campaign: campaign,
    referral: referral
  };
});